import React from "react";

export const Chat = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.178"
      height="25.178"
      viewBox="0 0 25.178 25.178"
    >
      <g id="chat" transform="translate(-0.005 0)">
        <g
          id="Group_12063"
          data-name="Group 12063"
          transform="translate(0.005 0)"
        >
          <path
            id="Path_225207"
            data-name="Path 225207"
            d="M2.908,19.637A4.9,4.9,0,0,1,.5,19a.759.759,0,0,1-.3-1.063,5.334,5.334,0,0,0,.687-4.1A16.483,16.483,0,0,1,0,9.64,9.706,9.706,0,0,1,9.872,0a9.757,9.757,0,0,1,9.471,9.662A9.751,9.751,0,0,1,5.959,18.589a4.966,4.966,0,0,1-3.051,1.048ZM1.886,17.981a3.468,3.468,0,0,0,3.423-.807.748.748,0,0,1,.842-.137,8.228,8.228,0,0,0,11.7-7.373A8.173,8.173,0,0,0,1.5,9.644a17.354,17.354,0,0,0,.875,4,6.674,6.674,0,0,1-.49,4.337Z"
            transform="translate(-0.005 0)"
            fill="#F9FBFC"
          />
        </g>
        <g
          id="Group_12064"
          data-name="Group 12064"
          transform="translate(8.925 8.71)"
        >
          <path
            id="Path_225208"
            data-name="Path 225208"
            d="M156.5,156.238a4.966,4.966,0,0,1-3.051-1.048,9.778,9.778,0,0,1-10.043-1.6.748.748,0,1,1,.978-1.132,8.27,8.27,0,0,0,8.873,1.185.748.748,0,0,1,.842.137,3.467,3.467,0,0,0,3.423.807,6.646,6.646,0,0,1-.277-5.087c.005-.015.011-.03.017-.045A8.257,8.257,0,0,0,156.022,141a.748.748,0,1,1,1.148-.959,9.714,9.714,0,0,1,2.235,6.2,9.6,9.6,0,0,1-.754,3.77,5.276,5.276,0,0,0,.561,4.531.759.759,0,0,1-.3,1.063,4.9,4.9,0,0,1-2.408.633Z"
            transform="translate(-143.147 -139.77)"
            fill="#F9FBFC"
          />
        </g>
        <g
          id="Group_12068"
          data-name="Group 12068"
          transform="translate(4.131 8.518)"
        >
          <g
            id="Group_12065"
            data-name="Group 12065"
            transform="translate(4.36)"
          >
            <ellipse
              id="Ellipse_98"
              data-name="Ellipse 98"
              cx="1.183"
              cy="1.183"
              rx="1.183"
              ry="1.183"
              fill="#F9FBFC"
            />
          </g>
          <g id="Group_12066" data-name="Group 12066">
            <ellipse
              id="Ellipse_99"
              data-name="Ellipse 99"
              cx="1.183"
              cy="1.183"
              rx="1.183"
              ry="1.183"
              fill="#F9FBFC"
            />
          </g>
          <g
            id="Group_12067"
            data-name="Group 12067"
            transform="translate(8.719)"
          >
            <ellipse
              id="Ellipse_100"
              data-name="Ellipse 100"
              cx="1.183"
              cy="1.183"
              rx="1.183"
              ry="1.183"
              fill="#F9FBFC"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
